<template>
	<table class="event-candidate-product-table">
		<thead>
			<tr class="event-candidate-product-table__tr">
				<th colspan="2">
					<label class="event-candidate-product-table__all-select">
						<input
							v-model="allCheckModel"
							:value="allCheck"
							type="checkbox"
							class="event-candidate-product-table__checkbox"
						/>
						전체선택
					</label>
				</th>
			</tr>
		</thead>
		<tbody>
			<tr
				v-for="item in productList"
				:key="item.idProduct"
				class="event-candidate-product-table__tr"
			>
				<th>
					<input
						v-model="checkedProductModel"
						:value="item.idProduct"
						:id="item.idProduct"
						type="checkbox"
						class="event-candidate-product-table__checkbox"
					/>
				</th>
				<td>
					<label
						:for="item.idProduct"
						class="event-candidate-product-table__product"
					>
						<span
							class="event-candidate-product-table__product-name"
							v-text="item.productName"
						/>
					</label>
				</td>
			</tr>
		</tbody>
	</table>
</template>
<script>
	export default {
		name: 'EventWinnerMappedPdtTable',
		props: {
			value: {
				type: Array,
				default: () => [],
			},
			productList: {
				type: Array,
				default: () => [],
			},
		},
		data() {
			return {
				allCheck: false,
			};
		},
		computed: {
			allCheckModel: {
				get() {
					return this.allCheck;
				},
				set(newVal) {
					this.$emit(
						'input',
						Array.isArray(this.productList) &&
							this.productList.length > 0 &&
							newVal === true
							? this.productList.map(item => item.idProduct)
							: []
					);
					this.allCheck = newVal;
				},
			},
			checkedProductModel: {
				get() {
					return this.value;
				},
				set(newList) {
					this.$emit('input', newList);
					if (this.productList.length === newList.length) {
						this.allCheck = true;
					} else if (this.productList.length > newList.length) {
						this.allCheck = false;
					}
				},
			},
		},
	};
</script>
<style lang="scss" scoped>
	.event-candidate-product-table {
		width: 100%;

		th,
		td {
			vertical-align: middle;
		}

		&__tr {
			border-bottom: solid 1px #dfe6ee;
		}

		&__all-select {
			display: flex;
			align-items: center;
			cursor: pointer;

			input {
				margin-right: 4px;
			}
		}

		&__checkbox {
			cursor: pointer;
			font-size: 20px;
		}

		&__product {
			cursor: pointer;
			display: inline-block;
			padding: 12px 0 12px 12px;
			font-size: 20px;
		}

		&__product-name {
			white-space: normal;
			word-break: break-all;
			word-wrap: break-word;
		}
	}
</style>
